// extracted by mini-css-extract-plugin
export default {"titlePage":"userOrg_titlePage__0A3pC"};